'use strict';

module.exports = function(Chart) {

	Chart.Radar = function(context, config) {
		config.type = 'radar';

		return new Chart(context, config);
	};

};



/*****************
 ** WEBPACK FOOTER
 ** ./~/chart.js/src/charts/Chart.Radar.js
 ** module id = 2426
 ** module chunks = 0
 **/